// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>32</span>&nbsp;&nbsp;I will run the way of your commandments,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;when you have set my heart at liberty.<br> </p> </div></div>";
// Exports
module.exports = code;